import ButtonSecondary from 'common/ButtonSecondary';
import SubHeading from 'common/SubHeading';
import URL from 'common/Url';
import { styled } from 'styled-components';

import React, { useState } from 'react';

import BusinessPopup from './BusinessPopup';

const DivStyled = styled.div`
    padding: 0;
    width: 100%;
    margin: 0;
    padding-left: 60px;
    padding-right: 60px;

    @media (max-width: 960px) {
        padding-left: 32px;
        padding-right: 32px;
    }

    @media (max-width: 640px) {
        padding-left: 20px;
        padding-right: 20px;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;
        padding-top: 40px;
    }

    .content {
        display: flex;
        flex-direction: row;
        padding: 32px;
        border-radius: 12px;
        border: 1px solid ${(props) => props.theme.border};
        background: ${(props) => props.theme.colorBoxBackground};
        gap: 10px;
    }

    .about {
        padding: 10px 0;
        color: ${(props) => props.theme.colorBlack};
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        max-width: 70%;
    }

    .about p {
        margin-bottom: 12px;
    }

    .about p:last-child {
        margin-bottom: 0;
    }

    .image {
        width: 100px;
        height: 100px;
        border-radius: 8px;
        flex-shrink: 0;
        border: 0.5px solid var(--Structural-Structure-3, #c4c4c4);
        align-self: flex-start;
        object-fit: cover;
    }
    
    .profile-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #E1E1E1;
        padding-bottom: 10px;
        font-weight: 700;
        font-size: 18px;
        gap: 10px;
    }
`;

const BusinessData = ({ data }) => {
    const [openPopup, setOpenPopup] = useState(false);
    const togglePopup = () => {
        setOpenPopup(!openPopup);
    };

    return (
        <>
            <DivStyled>
                <div className="header">
                    <SubHeading>Business Profile</SubHeading>
                    <ButtonSecondary className="btn" onClick={togglePopup}>
                        Edit Business Profile
                    </ButtonSecondary>
                </div>
                <div className="content">
                    <img src={data.image_url} alt="Delete" className="image" width={100} height={100} />
                    <div className={'ml-4 w-full'}>
                        <div className="profile-header">
                            <div>{data.name}</div>
                        </div>

                        <URL>
                            <a href={data.website_url} target="_blank" rel="noopener noreferrer">
                                {data.website_url}
                            </a>
                        </URL>
                        <div className="about">
                            {data.bio.split('\n').map((paragraph, index) => (
                                paragraph.trim() ? <p key={index}>{paragraph}</p> : null
                            ))}
                        </div>
                        <URL>{data.email}</URL>
                    </div>
                </div>
            </DivStyled>

            <BusinessPopup open={openPopup} onClose={togglePopup}></BusinessPopup>
        </>
    );
};

export default BusinessData;
